// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu_item[data-v-6bfcedb3]{text-decoration:none;color:#000}", ""]);
// Exports
module.exports = exports;
